

export const EventName = 'module_router_root_path_change';
class RootPathMap {
  /**
   * 存放weId的map
   */
   weIdMap = new Map<string, string>();

  /**
   * 存放rootPath的map
   */
  public rootPathMap = new Map<string, string[]>();

  /**
   * rootPath注册事件
   */
  public event: Event;

  /**
   * rootPath注册事件名称
   */
  public eventName: string = EventName;

  /**
   * 实例化路由工具，可以预传入路由表
   * @param paths 
   */
  constructor() {
    this.event = window.document.createEvent('Event');
    this.event.initEvent(this.eventName, true, true);
  }

  /**
   * 检测根路由是否已经注册
   * @param weId 需要检测的组件的weId
   * @param rootPath 需要检测的根路由
   * @returns 路由是否已经注册
   */
  checkRootPath = (rootPath: string): boolean => {
    return this.rootPathMap.get(rootPath) !== undefined;
  }

  /**
   * 检测根路由是否有效
   * @param weId 
   * @param rootPath 
   * @returns 
   */
  isRootPathEffect = (weId: string, rootPath: string): boolean => {
    const weIds = this.rootPathMap.get(rootPath);
    return weIds && weIds[0] === weId ? true : false;
  }

  /**
   * 根据weId查找与其最近匹配到的weId对应的rootPath
   * @param weId 
   */
  getRootPathByWeId = (weId: string) => {
    const weIds = this.weIdMap.keys();
    let matchedWeId = '';
    let idIter = weIds.next();
    while(!idIter.done) {
      if (weId.indexOf(idIter.value) !== -1 && idIter.value.length > matchedWeId.length) {
        matchedWeId = idIter.value;
      }
      idIter = weIds.next();
    }
    if (matchedWeId) {
      const rootPath = this.weIdMap.get(matchedWeId);
      if (rootPath && this.isRootPathEffect(matchedWeId, rootPath)) {
        return rootPath;
      }
    }
    return undefined;
  }

  /**
   * 注册根路由
   * @param weId 注册根路由的组件的weId
   * @param rootPath 需要注册的根路由
   * @returns 路由是否注册成功
   */
  registerRootPath = (weId: string, rootPath: string) => {
    const weIds = this.rootPathMap.get(rootPath);
    if (!weIds) {
      this.rootPathMap.set(rootPath, [weId]);
      this.weIdMap.set(weId, rootPath);
      // TODO: 通知到组件
      window.document.dispatchEvent(this.event);
    } else {
      const index = weIds.findIndex(id => id === weId);
      if (index === -1) {
        weIds.push(weId);
        this.rootPathMap.set(rootPath, weIds);
        this.weIdMap.set(weId, rootPath);
      }
    }
    return true;
  }

  /**
   * 从根路由表中删除根路由
   * @param weId 当前组件的weId
   * @param rootPath 需要删除的跟路由
   * @returns 是否删除成功
   */
  deleteRootPath = (weId: string, rootPath: string): boolean => {
    const weIds = this.rootPathMap.get(rootPath);
    if (!weIds) {
      this.weIdMap.delete(weId);
      return false;
    } else {
      const index = weIds.findIndex(id => id === weId);
      if (index !== -1) {
        let touchEvent = false;
        if (index === 0) {
          if (weIds.length !== 1) {
            touchEvent = true;
          }
        }
        weIds.splice(index, 1);
        if (weIds.length === 0) {
          this.rootPathMap.delete(rootPath);
        } else {
          this.rootPathMap.set(rootPath, weIds);
        }
        this.weIdMap.delete(weId);
        // TODO: 启用第二项weId作为有效
        if (touchEvent) {
          window.document.dispatchEvent(this.event);
        }
        return true;
      }
    }
    return false;
  }
}

export default RootPathMap;
